// src/components/AdminModeToggle.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

const MODES = [
  { id: "admin", label: "Admin", short: "Admin", path: "/admin" },
  { id: "startup", label: "Startup", short: "Startup", path: "/feed" },
  { id: "corporation", label: "Business Owner", short: "Owner", path: "/my-needs" },
];

export default function AdminModeToggle() {
  const { isAdmin, viewMode, setViewMode } = useAuth();
  const navigate = useNavigate();

  if (!isAdmin) return null;

  const activeMode = viewMode === "user" ? "startup" : viewMode;

  function setMode(next) {
    if (next === activeMode) return;
    setViewMode(next);
    const mode = MODES.find(m => m.id === next);
    if (mode) navigate(mode.path);
  }

  return (
    <div className="admin-mode-toggle" role="group" aria-label="Platform view">
      <div className="admin-mode-toggle-track" role="tablist" aria-label="Switch between Admin, Startup, and Business Owner views">
        {MODES.map(mode => {
          const active = activeMode === mode.id;
          return (
            <button
              key={mode.id}
              type="button"
              role="tab"
              aria-selected={active}
              aria-label={mode.label}
              title={mode.label}
              className={`admin-mode-toggle-option${active ? " is-active" : ""}`}
              onClick={() => setMode(mode.id)}
            >
              <span className="admin-mode-label-full">{mode.label}</span>
              <span className="admin-mode-label-short">{mode.short}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
